package songwritersnotebook.app.ui.theme

import androidx.compose.ui.graphics.Color

val DarkBackground = Color(0xFF111827) // bg-gray-900
val DarkSurface = Color(0xFF1F2937)   // bg-gray-800
val DarkPrimaryText = Color(0xFFFFFFFF)
val DarkSecondaryText = Color(0xFF9CA3AF) // text-gray-400
val BlueAccent = Color(0xFF3B82F6)
val GoldAccent = Color(0xFFFBBF24)// text-blue-500
val LightBackground = Color(0xFFF3F4F6)
val LightSurface = Color(0xFFFFFFFF)
val LightPrimaryText = Color(0xFF111827)
val LightSecondaryText = Color(0xFF4B5563)
val SliderTrackGray = Color(0xFF4A5568)
val SliderThumbGray = Color(0xFFCBD5E1)
val SuccessGreen = Color(0xFF10B981)
